module.exports = __webpack_public_path__ + "media/thats-looking-awesome-but-the-time-is-up.2f57781e.mp3";